import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { NavigationStart, NavigationEnd, Router } from "@angular/router";

declare let $: any;

// @dynamic
@Component({
    selector: 'fake-loader',
    templateUrl: './fakeloader.html',
    styleUrls: ['./fakeloader.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class FakeloaderComponent implements OnInit, OnChanges {

    static loading: boolean = false;
    @Input() imgPath: string = "/assets/images/loader.gif";
    @Input() timer: number;
    static _timer: number;
    static forceLoading: boolean = false;

    constructor(protected router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                FakeloaderComponent.startLoaderTimeOut();
            }
            if (event instanceof NavigationEnd) {
                FakeloaderComponent.stop();
            }
        });
    }

    ngOnInit() {
        FakeloaderComponent.startLoaderTimeOut();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['timer']) {
            const timer = changes['timer'].currentValue;
            FakeloaderComponent._timer = timer || 3500;
        }
    }

    get isLoading() {
        return FakeloaderComponent.loading;
    }

    static startLoaderTimeOut() {
        FakeloaderComponent.start();
        setTimeout(() => {
            FakeloaderComponent.stop();
        }, FakeloaderComponent._timer);
    }

    static start() {
        FakeloaderComponent.loading = true;
        $('html').addClass('loading');
    }

    static stop() {
        if(!FakeloaderComponent.forceLoading) {
            FakeloaderComponent.loading = false;
            $('html').removeClass('loading');
        }
    }

}
